<template>
    <app-layout>

        <div class="poster" v-if="settings.show_banners && banners && banners.length > 0">
            <div class="row column poster-inner">
                <swiper :options="swiperOptions" class="slider" :class="{ 'swiper-has-pagination': banners.length > 1 }">
                    <swiper-slide v-for="banner in banners" :key="banner.id">
                        <a :href="banner.target_url">
                            <img :src="banner.image.full_url" :alt="banner.title">
                        </a>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination" v-if="banners.length > 1"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>

        <div class="posts" v-if="settings.show_articles">
            <div class="row">
                <h3 class="column">Jaunumi</h3>
            </div>
            <div v-if="posts.length > 0" class="row small-up-1 medium-up-2 large-up-3 posts-list">
                <div class="column post-item-wrapper" v-for="post in posts" :key="post.id">
                    <post-item :post="post" class="post-item"/>
                </div>
            </div>
        </div>

        <div class="file-filter-container">
            <div class="row column clearfix">
                <material-filter :current.sync="sort" class="float-left"></material-filter>
                <router-link to="upload" class="button large primary float-right" style="margin:6.5px 0;" v-if="isAuthenticated">Pievienot materiālu</router-link>
            </div>
        </div>

        <div class="file-list-container">
            <div class="row column">
                <section class="file-list-section" v-for="category in categories" :key="category.id">
                    <header class="fancy"><span></span><h2>{{ category.category.title }}</h2><span></span></header>
                    <div class="row small-up-2 medium-up-3 large-up-5">
                        <spinner v-if="loading[category.category_id] === true" class="spinner"></spinner>
                        <template v-else="">
                            <div class="column" v-for="material in materials[category.category_id]" :key="material.id">
                                <material-item :material="material" v-on:update:material="updateMaterial($event)"></material-item>
                            </div>
                        </template>
                    </div>
                </section>
            </div>
        </div>

    </app-layout>
</template>

<script>
    import AppLayout from '../layouts/AppLayout.vue'
    import MaterialFilter from '../components/MaterialFilter'
    import MaterialItem from '../components/MaterialItem'
    import PostItem from '../components/posts/PostItem'
    import materials from '../api/materials'
    import posts from '../api/posts'
    import settings from '../api/settings';
    import { mapGetters } from 'vuex'
    import banners from '../api/banners'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.css'

    export default {

        data() {
            return {
                sort: 'created_at',
                materials: {},
                loading: {},
                banners: null,
                bannersPromise: null,
                posts: [],
                swiperOptions: {
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 0,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                settings: {
                    show_banners: null,
                    show_articles: null
                }
            }
        },

        created() {
            if (this.categories.length === 0) {
                this.$store.dispatch('getCategories')
            } else {
                this.loadMaterialsForCategories()
            }

            settings.get().then(settingsRes => {

                console.log(settingsRes);
                const s = settingsRes.data.find(s => s.name === 'front_page_settings') || { value: {} };
                this.settings = Object.assign({}, this.settings, s.value);

                if (this.settings.show_banners) {
                    this.loadBanners();
                }

                if (this.settings.show_articles) {
                    this.loadPosts();
                }
            });

        },

        watch: {
            'categories': function (value, oldValue) {
                this.loadMaterialsForCategories()
            },

            'sort': function (value, oldValue) {
                this.loadMaterialsForCategories()
            },
            'isAuthenticated': function (val) {
                this.loadMaterialsForCategories()
            }
        },

        methods: {
            loadMaterialsForCategories() {
                this.categories.forEach((categoryNode) => {
                    const category_id = categoryNode.category_id;

                    this.$set(this.loading, category_id, true);
                    materials.get({ categories: [category_id], sort: this.sort })
                        .then((response) => {
                            const c = {};
                            c[category_id] = response.data.data.slice(0, 5);
                            this.materials = Object.assign({}, this.materials, c);
                            this.$set(this.loading, category_id, false);
                        });
                });
            },

            /**
             *
             * @returns {AxiosPromise<any>}
             */
            loadBanners() {
                if (this.bannersPromise) {
                    return this.bannersPromise;
                } else {
                    this.bannersPromise = banners.get()
                        .then(response => {
                            this.banners = response.data;
                            this.bannersPromise = null;
                        });
                    return this.bannersPromise;
                }
            },

            loadPosts() {
                posts.get({ perPage: 3, orderBy: 'created_at', orderByDirection: 'desc' }).then(res => {
                    this.posts = res.data.data;
                });
            },

            updateMaterial(material) {
                for (let c_id in this.materials) {
                    this.materials[c_id].forEach((m, i, arr) => {
                        if (m.id === material.id)  arr.splice(i, 1, material);
                    })
                }
            },
        },

        computed: {
            ...mapGetters(['categories', 'isAuthenticated']),
        },

        components: {
            MaterialFilter, AppLayout, MaterialItem, swiper, swiperSlide, PostItem
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .poster {
        background-color: #00688b;
        // min-height: 245px;
        padding: 20px 0 20px 0;
        text-align: center;
        display: flex;
        align-items: center;

        h1 {
            font-size: 32px;
            color: white;
        }

        .poster-inner {
            flex-basis: 100%;
        }
    }

    /deep/ .swiper-button-disabled {
        display: none;
    }

    .posts {
        background-color: #06769b;
        padding: 20px 0 30px 0;

        h3 {
            color: white;
        }

        .posts-list {
            margin-bottom: -30px;
        }

        .post-item-wrapper {
            display: flex;
            align-items: stretch;
            margin-bottom: 30px;
        }
    }

    .file-filter-container {
        background-color: white;
    }

    .file-list-container {
        @include clearfix();
    }

    .file-list-section {
        margin: px-em(34px) 0;

        > header {
            h2 {
                font-size: px-em(20px);
                text-align: center;
            }
        }

        .small-up-2 {
            .column:nth-child(n+3) {
                display: none;
            }
        }

        /* Media queries for fitting materials in single row on smaller screens */
        .medium-up-3 {
            @include breakpoint(medium up) {
                .column:nth-child(-n+3) {
                    display: flex;
                }
            }
        }

        .large-up-5 {
            @include breakpoint(large up) {
                .column:nth-child(-n+6) {
                    display: flex;
                }
            }
        }
    }

    .slider {
        z-index: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Home.vue